/* https://redux.js.org/recipes/reducing-boilerplate#generating-reducers */
export default (initialState, actionHandlers) => (state = initialState, action) => {
  if (Object.prototype.hasOwnProperty.call(actionHandlers, action.type)) {
    return actionHandlers[action.type](state, action);
  }
  return state;
};
